(function () {
  'use strict';

  var MAX_FILE_BYTES = 5 * 1024 * 1024;
  var ACCEPTED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];
  var OWNER_PATH = '製品を持っている';
  var SAMPLE_PATH = '無料サンプルに応募';

  function initCreatorProgramV2(root) {
    if (!root || root.dataset.cpV2Initialized === 'true') return;

    var form = root.querySelector('[data-cp-form-v2]');
    if (!form) return;
    root.dataset.cpV2Initialized = 'true';

    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-cp-v2-step]'));
    var progressButtons = Array.prototype.slice.call(root.querySelectorAll('[data-cp-v2-progress]'));
    var pathInputs = Array.prototype.slice.call(form.querySelectorAll('input[name="application_path"]'));
    var routePanels = Array.prototype.slice.call(form.querySelectorAll('[data-cp-v2-route-panel]'));
    var successMessage = root.querySelector('[data-cp-v2-success]');
    var errorMessage = root.querySelector('[data-cp-v2-error]');
    var submitButton = form.querySelector('[data-cp-v2-submit]');
    var startedAt = form.querySelector('[data-cp-v2-started-at]');
    var submittedAt = form.querySelector('[data-cp-v2-submitted-at]');
    var routeField = form.querySelector('[data-cp-v2-form-route]');
    var userAgent = form.querySelector('[data-cp-v2-user-agent]');
    var currentStep = 1;
    var slowNoticeTimer;

    if (startedAt) startedAt.value = String(Date.now());
    if (userAgent) userAgent.value = navigator.userAgent || '';

    try {
      var urlParams = new URLSearchParams(window.location.search);
      Array.prototype.slice.call(form.querySelectorAll('[data-cp-v2-utm]')).forEach(function (field) {
        field.value = urlParams.get(field.getAttribute('data-cp-v2-utm')) || '';
      });
    } catch (error) {
      // UTM values are optional; submission remains available if URL parsing fails.
    }

    function selectedPath() {
      var selected = pathInputs.find(function (input) { return input.checked; });
      return selected ? selected.value : '';
    }

    function setControlsDisabled(container, disabled) {
      if (!container) return;
      Array.prototype.slice.call(container.querySelectorAll('input, select, textarea, button')).forEach(function (control) {
        control.disabled = disabled;
      });
    }

    function clearMessages() {
      if (successMessage) successMessage.hidden = true;
      if (errorMessage) errorMessage.hidden = true;
    }

    function showMessage(target, message) {
      if (!target) return;
      target.textContent = message;
      target.hidden = false;
      if (target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function showError(message) {
      if (successMessage) successMessage.hidden = true;
      showMessage(errorMessage, message || '入力内容をご確認ください。');
    }

    function syncRoute() {
      var path = selectedPath();
      if (routeField) routeField.value = path === OWNER_PATH ? 'product_owner' : path === SAMPLE_PATH ? 'sample_applicant' : '';

      routePanels.forEach(function (panel) {
        var active = panel.getAttribute('data-cp-v2-route-panel') === path;
        panel.hidden = !active;
        setControlsDisabled(panel, !active || currentStep !== 2);
      });

      if (submitButton) {
        submitButton.textContent = path === OWNER_PATH
          ? '参加を申し込む'
          : path === SAMPLE_PATH
            ? '無料サンプルに応募する'
            : '申請内容を送信する';
      }
    }

    function setStep(stepNumber, shouldFocus) {
      currentStep = Math.max(1, Math.min(2, Number(stepNumber) || 1));

      steps.forEach(function (step) {
        var active = Number(step.getAttribute('data-cp-v2-step')) === currentStep;
        step.hidden = !active;
        step.disabled = !active;
        step.classList.toggle('is-active', active);
      });

      progressButtons.forEach(function (button) {
        var index = Number(button.getAttribute('data-cp-v2-progress'));
        button.classList.toggle('is-active', index === currentStep);
        button.classList.toggle('is-complete', index < currentStep);
        button.setAttribute('aria-current', index === currentStep ? 'step' : 'false');
      });

      syncRoute();

      if (shouldFocus) {
        var activeStep = steps.find(function (step) { return Number(step.getAttribute('data-cp-v2-step')) === currentStep; });
        var legend = activeStep && activeStep.querySelector('legend');
        if (legend) {
          legend.setAttribute('tabindex', '-1');
          legend.focus({ preventScroll: true });
        }
        var shell = root.querySelector('.creator-program__form-shell');
        if (shell && shell.scrollIntoView) shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function validateCheckboxGroup(name, container, message) {
      if (container && container.querySelector('input[name="' + name + '"]:checked')) return true;
      showError(message);
      var first = container && container.querySelector('input[name="' + name + '"]');
      if (first) first.focus();
      return false;
    }

    function validateSampleEligibility(panel) {
      var age = panel && panel.querySelector('input[name="age_18_plus"]:checked');
      var japan = panel && panel.querySelector('input[name="japan_resident_domestic_shipping"]:checked');
      var followers = Number(panel && panel.querySelector('input[name="followers"]') && panel.querySelector('input[name="followers"]').value);

      if (!age || !japan || !Number.isFinite(followers)) return true;
      if (age.value === 'はい' && japan.value === 'はい' && followers >= 1000) return true;

      showError('申し訳ありません。無料サンプルは、18歳以上で日本在住かつ国内配送を受け取れる方、公開アカウントで1,000人以上のフォロワー・登録者をお持ちの方が対象です。');
      if (age.value !== 'はい') age.focus();
      else if (japan.value !== 'はい') japan.focus();
      else {
        var followerField = panel.querySelector('input[name="followers"]');
        if (followerField) followerField.focus();
      }
      return false;
    }

    function firstInvalidControl(container) {
      if (!container) return null;
      var controls = Array.prototype.slice.call(container.querySelectorAll('input, select, textarea'));
      return controls.find(function (control) {
        return !control.disabled && typeof control.checkValidity === 'function' && !control.checkValidity();
      }) || null;
    }

    function validateCurrentStep() {
      clearMessages();
      var activeStep = steps.find(function (step) { return Number(step.getAttribute('data-cp-v2-step')) === currentStep; });
      if (!activeStep) return false;

      var invalidControl = firstInvalidControl(activeStep);
      if (invalidControl) {
        invalidControl.reportValidity();
        if (invalidControl.focus) invalidControl.focus({ preventScroll: true });
        if (invalidControl.scrollIntoView) invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }

      var path = selectedPath();
      if (currentStep === 1 && !path) {
        showError('参加方法を選択してください。');
        return false;
      }

      if (currentStep === 2 && path === SAMPLE_PATH) {
        var samplePanel = root.querySelector('[data-cp-v2-route-panel="' + SAMPLE_PATH + '"]');
        if (!validateSampleEligibility(samplePanel)) return false;
        if (!validateCheckboxGroup('content_category', samplePanel, '主なコンテンツ分野を1つ以上選択してください。')) return false;
      }

      return true;
    }

    function localizedValidity(field) {
      if (!field || !field.validity) return '';
      if (field.validity.valueMissing) {
        if (field.type === 'checkbox' || field.type === 'radio') return 'この項目を確認してください。';
        if (field.type === 'file') return 'ファイルを選択してください。';
        if (field.tagName === 'SELECT') return 'この項目を選択してください。';
        return 'この項目を入力してください。';
      }
      if (field.validity.typeMismatch && field.type === 'email') return 'メールアドレスを正しく入力してください。';
      if (field.validity.typeMismatch && field.type === 'url') return 'URLを https:// から正しく入力してください。';
      if (field.validity.patternMismatch && field.name === 'shipping_postal_code') return '郵便番号を7桁で入力してください（例：100-0001）。';
      if (field.validity.patternMismatch && field.name === 'shipping_phone') return '電話番号を正しく入力してください（例：090-1234-5678）。';
      if (field.validity.rangeUnderflow || field.validity.rangeOverflow || field.validity.badInput) return '入力値を確認してください。';
      return '';
    }

    Array.prototype.slice.call(form.querySelectorAll('input, select, textarea')).forEach(function (field) {
      field.addEventListener('invalid', function () {
        field.setCustomValidity('');
        field.setCustomValidity(localizedValidity(field));
      });
      field.addEventListener('input', function () { field.setCustomValidity(''); });
      field.addEventListener('change', function () { field.setCustomValidity(''); });
    });

    pathInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        clearMessages();
        syncRoute();
      });
    });

    root.creatorProgramChoosePath = function (value) {
      var target = pathInputs.find(function (input) { return input.value === value; });
      if (target) {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
      setStep(1, false);
      var shell = root.querySelector('.creator-program__form-shell');
      if (shell && shell.scrollIntoView) shell.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    progressButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var targetStep = Number(button.getAttribute('data-cp-v2-progress'));
        if (targetStep < currentStep) setStep(targetStep, true);
      });
    });

    Array.prototype.slice.call(form.querySelectorAll('[data-cp-v2-next]')).forEach(function (button) {
      button.addEventListener('click', function () {
        if (!validateCurrentStep()) return;
        setStep(currentStep + 1, true);
      });
    });

    Array.prototype.slice.call(form.querySelectorAll('[data-cp-v2-prev]')).forEach(function (button) {
      button.addEventListener('click', function () {
        clearMessages();
        setStep(currentStep - 1, true);
      });
    });

    Array.prototype.slice.call(form.querySelectorAll('[data-cp-v2-file]')).forEach(function (input) {
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        var display = input.closest('.creator-program__upload').querySelector('[data-cp-v2-file-name]');
        input.setCustomValidity('');
        if (!file) {
          if (display) display.textContent = display.getAttribute('data-cp-v2-file-default') || 'ファイルを選択してください。';
          return;
        }
        if (file.size > MAX_FILE_BYTES) input.setCustomValidity('ファイルは5MB以内にしてください。');
        if (ACCEPTED_FILE_TYPES.indexOf(String(file.type).toLowerCase()) === -1) input.setCustomValidity('JPG、PNG、WEBP、PDF形式を選択してください。');
        if (display) display.textContent = file.name + '（' + Math.max(1, Math.round(file.size / 1024)) + 'KB）';
      });
    });

    function appendPayloadValue(payload, name, value) {
      if (Object.prototype.hasOwnProperty.call(payload, name)) {
        if (!Array.isArray(payload[name])) payload[name] = [payload[name]];
        payload[name].push(value);
      } else {
        payload[name] = value;
      }
    }

    function buildFieldPayload() {
      var payload = {};
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (!field.name || field.disabled) return;
        if (field.type === 'file' || field.type === 'submit' || field.type === 'button') return;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
        appendPayloadValue(payload, field.name, field.value);
      });
      return payload;
    }

    function fileToBase64WebSafe(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          var result = String(reader.result || '');
          var commaIndex = result.indexOf(',');
          var base64 = commaIndex >= 0 ? result.slice(commaIndex + 1) : result;
          resolve(base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, ''));
        };
        reader.onerror = function () { reject(new Error('添付ファイルを読み込めませんでした。')); };
        reader.readAsDataURL(file);
      });
    }

    function createApplicationId() {
      var now = new Date();
      var stamp = [
        now.getFullYear(),
        String(now.getMonth() + 1).padStart(2, '0'),
        String(now.getDate()).padStart(2, '0'),
        String(now.getHours()).padStart(2, '0'),
        String(now.getMinutes()).padStart(2, '0'),
        String(now.getSeconds()).padStart(2, '0')
      ].join('');
      var random = Math.floor(Math.random() * 1000000).toString().padStart(6, '0');
      return 'CP-' + stamp + '-' + random;
    }

    function buildAppsScriptPayload() {
      if (submittedAt) submittedAt.value = new Date().toISOString();
      var activeFiles = Array.prototype.slice.call(form.querySelectorAll('input[type="file"]')).filter(function (input) {
        return !input.disabled && input.files && input.files[0];
      });
      return Promise.all(activeFiles.map(function (input) {
        var file = input.files[0];
        if (file.size > MAX_FILE_BYTES) throw new Error('添付ファイルは1件につき5MB以内にしてください。');
        if (ACCEPTED_FILE_TYPES.indexOf(String(file.type).toLowerCase()) === -1) throw new Error('添付できる形式はJPG、PNG、WEBP、PDFです。');
        return fileToBase64WebSafe(file).then(function (data) {
          return { fieldName: input.name, name: file.name, type: file.type, size: file.size, data: data };
        });
      })).then(function (files) {
        return { applicationId: createApplicationId(), fields: buildFieldPayload(), files: files };
      });
    }

    function isTrustedAppsScriptOrigin(origin) {
      try {
        var hostname = new URL(origin).hostname;
        return hostname === 'script.google.com' || hostname === 'script.googleusercontent.com' || hostname.slice(-22) === '.googleusercontent.com';
      } catch (error) {
        return false;
      }
    }

    function submitWithAppsScript(payload) {
      return new Promise(function (resolve, reject) {
        var frameName = form.id + '-receiver-frame';
        var iframe = document.createElement('iframe');
        var transportForm = document.createElement('form');
        var payloadField = document.createElement('textarea');
        var callbackName = 'creatorProgramStatus_' + payload.applicationId.replace(/[^0-9A-Za-z_]/g, '_');
        var timeoutId;
        var pollTimer;
        var pollDelay = 7000;
        var completed = false;

        function cleanup() {
          window.clearTimeout(timeoutId);
          window.clearTimeout(pollTimer);
          window.removeEventListener('message', handleMessage);
          try { delete window[callbackName]; } catch (error) { window[callbackName] = undefined; }
          if (transportForm.parentNode) transportForm.parentNode.removeChild(transportForm);
          window.setTimeout(function () { if (iframe.parentNode) iframe.parentNode.removeChild(iframe); }, 1000);
        }

        function finishSuccess(data) {
          if (completed) return;
          completed = true;
          cleanup();
          resolve(data || { ok: true });
        }

        function finishError(error) {
          if (completed) return;
          completed = true;
          cleanup();
          reject(error);
        }

        function schedulePoll() {
          pollTimer = window.setTimeout(pollStatus, pollDelay);
          pollDelay = Math.min(Math.round(pollDelay * 1.5), 20000);
        }

        function pollStatus() {
          var script = document.createElement('script');
          var separator = form.action.indexOf('?') === -1 ? '?' : '&';
          window[callbackName] = function (data) {
            if (data && data.ok && data.found) return finishSuccess(data);
            if (data && data.ok === false) return finishError(new Error(data.message || '送信に失敗しました。'));
            schedulePoll();
          };
          script.async = true;
          script.src = form.action + separator + 'action=status&application_id=' + encodeURIComponent(payload.applicationId) + '&callback=' + encodeURIComponent(callbackName) + '&_=' + Date.now();
          script.onload = script.onerror = function () {
            window.setTimeout(function () { if (script.parentNode) script.parentNode.removeChild(script); }, 0);
          };
          document.head.appendChild(script);
        }

        function handleMessage(event) {
          if (!isTrustedAppsScriptOrigin(event.origin)) return;
          var data = event.data;
          if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch (error) { return; }
          }
          if (!data || data.source !== 'creator-program-receiver') return;
          if (data.ok) finishSuccess(data);
          else finishError(new Error(data.message || '送信に失敗しました。'));
        }

        iframe.name = frameName;
        iframe.hidden = true;
        iframe.style.display = 'none';
        transportForm.method = 'post';
        transportForm.action = form.action;
        transportForm.target = frameName;
        transportForm.style.display = 'none';
        payloadField.name = 'payload';
        payloadField.value = JSON.stringify(payload);
        transportForm.appendChild(payloadField);

        window.addEventListener('message', handleMessage);
        timeoutId = window.setTimeout(function () {
          finishError(new Error('送信結果を確認できませんでした。重複送信を避けるため、すぐに再送せず、受付メールをご確認ください。'));
        }, 300000);
        schedulePoll();
        document.body.appendChild(iframe);
        document.body.appendChild(transportForm);
        transportForm.submit();
      });
    }

    function setSubmitting(isSubmitting) {
      window.clearTimeout(slowNoticeTimer);
      form.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
      if (submitButton) {
        submitButton.disabled = isSubmitting || root.dataset.formReady !== 'true';
        if (isSubmitting) submitButton.textContent = '送信中です…';
        else syncRoute();
      }
      if (isSubmitting) {
        slowNoticeTimer = window.setTimeout(function () {
          showMessage(successMessage, '添付ファイルと申請内容を送信しています。この画面を閉じずにお待ちください。');
        }, 12000);
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearMessages();

      if (root.dataset.formReady !== 'true' || !form.action) {
        showError('現在はテスト準備中です。送信先の設定後に応募できるようになります。');
        return;
      }

      if (!validateCurrentStep()) return;
      var submittedPath = selectedPath();
      setSubmitting(true);

      buildAppsScriptPayload()
        .then(submitWithAppsScript)
        .then(function () {
          form.reset();
          if (startedAt) startedAt.value = String(Date.now());
          if (submittedAt) submittedAt.value = '';
          if (userAgent) userAgent.value = navigator.userAgent || '';
          Array.prototype.slice.call(form.querySelectorAll('[data-cp-v2-file-name]')).forEach(function (node) {
            node.textContent = node.getAttribute('data-cp-v2-file-default') || 'ファイルを選択してください。';
          });
          setStep(1, false);
          showMessage(
            successMessage,
            submittedPath === OWNER_PATH
              ? 'お申し込みありがとうございます。内容と製品所有を確認後、確認結果と次の手続きをご入力のメールアドレスへご案内します。'
              : 'ご応募ありがとうございます。Rokidチームにて内容を確認後、選考結果をご入力のメールアドレスへご案内します。'
          );
        })
        .catch(function (error) {
          showError(error && error.message ? error.message : '送信できませんでした。時間をおいてもう一度お試しください。');
        })
        .finally(function () { setSubmitting(false); });
    });

    setStep(1, false);
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-creator-program]')).forEach(initCreatorProgramV2);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
